export default __webpack_public_path__ + "static/media/bulletin-notice-black.11f97146.svg";